module.exports = __webpack_public_path__ + "549bb28d9a3246e3f5adc95fec6a588c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gallery/v/v24.jpg
// module id = 772
// module chunks = 0